// Scripts librairies
import { docReady } from './js/libs/utils'

// style
import './scss/pages/advices'

// Charge la base commune
require('./common.js')

docReady(function () {
  const target = document.querySelector('#go')
  if (target) {
    target.scrollIntoView({ behavior: 'smooth' })
  }
})
